import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageProjects,
  DeleteProjects,
  EditProjects,
  GetProjects,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { useNavigate } from 'react-router-dom';
import { RouterName } from 'src/routes/RouterName';
import { ClassNames } from "@emotion/react";

const Projects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);

  const privilegeId = "8";
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    full_desc: Yup.string().trim().required("Description is required"),
    image: Yup.mixed().required("Image is required"),
    slug: Yup.string().trim().required("Slug is required"),
    meta_key: Yup.string().trim().required("Meta key is required"),
    meta_desc: Yup.string().trim().required("Meta description is required"),
    page_title: Yup.string().trim().required("Page title is required"),
    year: Yup.string()
      .trim()
      .nullable()
      .matches(
        /^(19|20)\d{2}$/,
        'Year must be a valid 4-digit year (1900-2099)'
      )
      .test(
        'max-current-year',
        'Year cannot be in the future',
        value => !value || parseInt(value) <= new Date().getFullYear()
      ),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetProjects({
        callback: (response) => {
          const responseData = response?.data;

          if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
            setData([responseData]);
            setTotalData(1);
          } else if (isValidArray(responseData)) {
            setData(responseData);
            setTotalData(responseData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );

    if (array.length === 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "title",
          type: inputType.text,
          title: "Title",
          placeholder: "Enter title",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "full_desc",
          type: inputType.textarea,
          title: "Full Description",
          placeholder: "Enter full description",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "image",
          type: inputType.image,
          title: "Image",
          placeholder: "Upload image",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "location",
          type: inputType.text,
          title: "Location",
          placeholder: "Enter location",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "client",
          type: inputType.text,
          title: "Client",
          placeholder: "Enter client",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "year",
          type: inputType.text,
          title: "Year",
          placeholder: "Enter year (YYYY)",
          fullwidth: true,
          customdesign: { width: "100%" },
          inputProps: {
            maxLength: 4,
            pattern: "\\d{4}",
            title: "Please enter a 4-digit year (e.g., 2023)",
          },
        },
        {
          failed: "slug",
          type: inputType.text,
          title: "Slug",
          placeholder: "Enter slug",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "meta_key",
          type: inputType.text,
          title: "Meta Key",
          placeholder: "Enter meta key",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "meta_desc",
          type: inputType.text,
          title: "Meta Description",
          placeholder: "Enter meta description",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "page_title",
          type: inputType.text,
          title: "Page Title",
          placeholder: "Enter page title",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "full_desc", isSmall: "true"},
    {
      type: columntype.image,
      name: "image",
      options: {
        width: 100,
        height: 100
      }
    },
    { type: columntype.text, name: "location" },
    { type: columntype.text, name: "client" },
    { type: columntype.text, name: "year" },
    { type: columntype.text, name: "slug" },
    { type: columntype.text, name: "meta_key" },
    { type: columntype.text, name: "meta_desc" },
    { type: columntype.text, name: "page_title" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: "ID",
      withSort: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      label: "Title",
      withSort: false,
    },
    {
      id: "full_desc",
      numeric: false,
      disablePadding: true,
      label: "Full Description",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: true,
      label: "Image",
      withSort: false,
    },
    {
      id: "location",
      numeric: false,
      disablePadding: true,
      label: "Location",
      withSort: false,
    },
    {
      id: "client",
      numeric: false,
      disablePadding: true,
      label: "Client",
      withSort: false,
    },
    {
      id: "year",
      numeric: false,
      disablePadding: true,
      label: "Year",
      withSort: false,
    },
    {
      id: "slug",
      numeric: false,
      disablePadding: true,
      label: "Slug",
      withSort: false,
    },
    {
      id: "meta_key",
      numeric: false,
      disablePadding: true,
      label: "Meta Key",
      withSort: false,
    },
    {
      id: "meta_desc",
      numeric: false,
      disablePadding: true,
      label: "Meta Description",
      withSort: false,
    },
    {
      id: "page_title",
      numeric: false,
      disablePadding: true,
      label: "Page Title",
      withSort: false,
    },
    (dataPrivileges[privilegeId]?.access_edit == 1 ||
      dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Actions",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Delete ${row?.title ?? "this item"}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteProjects({
                      callback: () => GetData(),
                      id: [row?.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    {
      name: "Media",
      function: async (data) => {
        navigate(`/media/project/${data.id}`);
      },
    }
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditProjects({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
          GetData();
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, type) => tableName && type && GetData({ tableName, type })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteProjects({
                      callback: () => GetData(),
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => { }}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />

      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Projects"}
          editMode={editMode}
          description={editMode ? "Edit Project" : "Add New Project"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(values) => {
            dispatch(
              ManageProjects({
                editMode: editMode,
                values,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      )}
    </>
  );
};

export default Projects;